import '../styles/main.scss';

import App from "./App.js"

function start() {
  gsap.registerPlugin(Draggable, InertiaPlugin, ScrollTrigger, SplitText);
  window.app = new App();
}

// Start as soon as the DOM and the web fonts are ready, not on `load`: the
// browser delays `load` until every <video> on the page has its first frame,
// which on a phone connection kept the intro's "Skip intro" button hidden for
// many seconds. Fonts are awaited because the intro measures glyph positions.
// ScrollTrigger refreshes itself on `load`, so pinned sections stay correct.
const domReady = new Promise((resolve) => {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", resolve, { once: true });
  } else {
    resolve();
  }
});
const fontsReady = document.fonts ? document.fonts.ready : Promise.resolve();

Promise.all([domReady, fontsReady]).then(start);
